<template>
  <div
    v-if="startType"
    class="pb-5"
  >
    <div class="c-outline text-center py-6 px-3 mt-4 mb-10">
      <p class="text-h6 font-weight-bold">
        본 교육은 설문조사, 역량평가, 퀴즈, 만족도 조사 등 모두 응시하셔야 연수평점을 부여받으실 수 있습니다.
      </p>
      <p class="mb-0">
        * 본인은 교육에 있어 <span class="text-decoration-underline">설문조사, 역량평가, 퀴즈, 만족도 조사</span>에 참여한 결과는 <br>
        연수교육평가를 위한 개인정보 수집 및 이용에 동의한 경우에만 활용합니다.
      </p>
    </div>

    <div class="purple lighten-4 py-2 px-3 font-weight-bold">
      ■ 설문조사
    </div>

    <v-col cols="12" md="4" class="mt-n4">
      <v-form
        ref="form"
        :readonly="$store.state.stateStream_survey_requesting"
      >
        <v-radio-group
          v-model="$store.state.stateStream_survey_form_header.gender"
          class="ml-n1"
          :rules="[gc_rules.required]"
          dense
          row
        >
          <v-radio label="남자" :value="1"/>
          <v-radio label="여자" :value="2"/>
        </v-radio-group>
        <v-text-field
          v-model="$store.state.stateStream_survey_form_header.age"
          label="연령"
          type="number"
          min="1"
          max="100"
          step="1"
          :rules="[gc_rules.required]"
          dense
        />
        <v-text-field
          v-model="$store.state.stateStream_survey_form_header.medical_course"
          label="주 진료 과목"
          :rules="[gc_rules.required]"
          dense
        />
      </v-form>
    </v-col>
  </div>

  <div v-else class="pb-5">
    <div class="purple lighten-4 py-2 px-3 font-weight-bold mt-4 mb-10">
      ■ 만족도 조사
    </div>

    <div class="c-outline text-center py-6 px-3">
      <p class="mb-0">
        * 본 설문은 참여자들을 대상으로 교육 만족도 및 요구를 알아보기 위한 것입니다. <br>
        각 문항에 대하여 귀하의 의견과 가장 가까운 점수에 체크 하여 주십시오.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StreamDialogSurveyHeader',

  methods: {
    validate() {
      return this.startType ?
        this.$refs.form.validate() : true
    }
  },

  computed: {
    startType() {
      return this.$store.state.stateStream_survey_info.survey_type === 0
    }
  }
}
</script>

<style lang="sass" scoped>
.c-outline
  outline: 1px solid #000000
</style>